function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
module.exports = function (purchaseService, _ref, priceTaxFeeAdjusterBase, clone) {
  var isProduct = _ref.isProduct,
    round = _ref.round;
  var excludedDepts = [];
  var priceTaxFeeAdjuster = /*#__PURE__*/function (_priceTaxFeeAdjusterB) {
    function priceTaxFeeAdjuster(supplementalData) {
      var _this;
      _classCallCheck(this, priceTaxFeeAdjuster);
      _this = _callSuper(this, priceTaxFeeAdjuster, [supplementalData]);
      _this.name = "feebuster";
      _this.id = priceTaxFeeAdjuster.nextId;
      priceTaxFeeAdjuster.nextId++;
      _this.priority = priceTaxFeeAdjuster.taxPriority - 1050; // so it comes before fees but after modifiers
      _this.supplementalData = supplementalData;
      excludedDepts = supplementalData.excludedDepts;
      return _this;
    }
    _inherits(priceTaxFeeAdjuster, _priceTaxFeeAdjusterB);
    return _createClass(priceTaxFeeAdjuster, [{
      key: "calculate",
      value: function calculate(productlist) {
        var _this2 = this;
        var feeBusterConfig = purchaseService.feeBusterConfig;
        var priceIncrease = purchaseService.priceIncrease;
        var excludedDepts = this.supplementalData && this.supplementalData.excludedDepts || [];
        productlist.filter(function (a) {
          return isProduct(a);
        }).forEach(function (p) {
          p.priceTaxFeeAdjustments = p.priceTaxFeeAdjustments ? p.priceTaxFeeAdjustments.filter(function (a) {
            return !(a.name === _this2.name && a.id === _this2.id);
          }) : [];
          var nogpi = excludedDepts.includes(p.dept);
          var feeBusterPTF = {
            name: _this2.name,
            id: _this2.id,
            priority: _this2.priority,
            price: nogpi ? 0 : round(p.intCcPrice - p.intPrice) * (p.refund ? -1 : 1),
            tax: 0,
            fee: 0,
            extra: {
              config: Object.assign({
                priceIncrease: priceIncrease
              }, feeBusterConfig),
              cashPrice: clone(p)
            }
          };
          var modifiers = p.priceTaxFeeAdjustments.filter(function (a) {
            return a.name === "itemModifierPTF";
          });
          modifiers.forEach(function (modifier) {
            var feebusterfee = nogpi ? 0 : round(modifier.price * feeBusterConfig.fraction);
            modifier.price += feebusterfee;
            modifier.extra.feebuster = feebusterfee;
          });
          var cashPriceItem = feeBusterPTF.extra.cashPrice;
          cashPriceItem.getPrice = function () {
            return purchaseService.getPriceFn(feeBusterPTF.extra.cashPrice);
          };
          cashPriceItem.cashPrice = true;
          cashPriceItem.source = p;
          p.priceTaxFeeAdjustments.push(feeBusterPTF);
        });
      }
    }, {
      key: "setSupplementalData",
      value: function setSupplementalData(supplementalData) {
        this.supplementalData = supplementalData;
      }
    }]);
  }(priceTaxFeeAdjusterBase);
  priceTaxFeeAdjuster.nextId = 0;
  priceTaxFeeAdjuster.taxPriority = 0; // so positive priorities are post-tax adjusters and negative values are pre-tax

  var productPriceMustBeIncreased = function productPriceMustBeIncreased(p) {
    return purchaseService.priceIncrease && !excludedDepts.includes(p.dept);
  };
  var neutralizeFeebusterCircularReference = function neutralizeFeebusterCircularReference(p) {
    if (p.priceTaxFeeAdjustments) {
      p.priceTaxFeeAdjustments.forEach(function (a) {
        if (a.name === "feebuster") {
          a.extra.cashPrice.source = null;
        }
      });
    }
  };
  return {
    priceTaxFeeAdjuster: priceTaxFeeAdjuster,
    productPriceMustBeIncreased: productPriceMustBeIncreased,
    neutralizeFeebusterCircularReference: neutralizeFeebusterCircularReference
  };
}(require('../../module/purchase/service.js'), require("../../utils.js"), require("../base.js"), require("clone"));